/* Ziggy Cuts — quick-add.js
   Adds a product to the cart straight from a shop card. If the scent has a
   single size it adds immediately; if multiple, it reveals a small size
   chooser on the card. Uses window.ZiggyCart (cart-drawer.js). */

(function () {
  'use strict';

  function addVariant(id, btn) {
    if (!window.ZiggyCart) { window.location.href = '/cart'; return; }
    if (btn) btn.setAttribute('aria-busy', 'true');
    window.ZiggyCart.addVariant(id, 1).finally(function () {
      if (btn) btn.removeAttribute('aria-busy');
    });
  }

  function money(s) { return s; }

  document.querySelectorAll('[data-quick-add]').forEach(function (wrap) {
    var variants;
    try { variants = JSON.parse(wrap.getAttribute('data-quick-add')); }
    catch (e) { return; }
    if (!variants || !variants.length) return;

    var trigger = wrap.querySelector('[data-quick-btn]');
    if (!trigger) return;

    function reset() {
      wrap.classList.remove('is-choosing');
      var chooser = wrap.querySelector('[data-quick-sizes]');
      if (chooser) chooser.remove();
      trigger.hidden = false;
    }

    function openChooser() {
      trigger.hidden = true;
      wrap.classList.add('is-choosing');
      var chooser = document.createElement('div');
      chooser.className = 'product-card__sizes';
      chooser.setAttribute('data-quick-sizes', '');
      variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'product-card__size';
        b.textContent = v.size;
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          addVariant(v.id, b);
          reset();
        });
        chooser.appendChild(b);
      });
      wrap.appendChild(chooser);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (variants.length === 1) {
        addVariant(variants[0].id, trigger);
      } else {
        if (wrap.classList.contains('is-choosing')) reset();
        else openChooser();
      }
    });

    // Close the chooser when clicking elsewhere
    document.addEventListener('click', function (e) {
      if (wrap.classList.contains('is-choosing') && !wrap.contains(e.target)) reset();
    });
  });
})();
